export const CheckPermission = (id: any) => {
    const access_string = localStorage.getItem('groupAccess')
    if (access_string) {
        if (access_string != '-1') {
            const access = JSON.parse(String(localStorage.getItem('groupAccess')))
            for (let i of access) {
                if (i.id == id) {
                    return true
                }
            }
            return false
        }
        else {
            return true
        }
    }
    else {
        return false
    }
}